import type { ReactNode } from "react";

import { Footer } from "./Footer";
import { Navbar } from "./Navbar";

type AppLayoutProps = {
	children: ReactNode;
};

export function AppLayout({ children }: AppLayoutProps) {
	return (
		<div className="flex min-h-screen flex-col bg-pastel-white">
			<Navbar />
			<main className="flex-1">{children}</main>
			<Footer />
		</div>
	);
}
